import styled, { css } from 'styled-components';

export const SaveOptionContainer = styled.div<{
  direction: 'ltr' | 'rtl';
}>`
  display: flex;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

export const SaveIconWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    margin-inline-end: 4px;
  }
`;

export const SaveTextWrapper = styled.div`
  font-size: 18px;
  line-height: 26px;
  text-wrap: nowrap;

  @media only screen and (max-width: 370px) {
    font-size: 16px;
  }
`;
